/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react'
import {
    Create,
    Edit,
    required,
    SimpleForm,
    TextInput,
    NumberInput,
    useNotify,
    useRefresh,
    useRedirect,
    AutocompleteInput,
    useDataProvider,
    DateInput,
} from 'react-admin'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core'
import BackButton from '../../components/BackButton'
import Title from '../../components/Title/Title'
import '../style.css'
import CustomValidater from '../../components/Utility/Validater'
import CustomCheckbox from '../../components/CustomCheckbox/CustomCheckbox'
import SearchReferenceInput from '../../components/QuickSearch/QuickSearch'
import EmployeeMasterList from '../EmployeeMaster/EmployeeMasterList'

const styles = {
    field: {
        width: '100%',
    },
}

const useStyles = makeStyles(styles)

const EmployeeAdvanceComponent = (props) => {
    const user = useSelector((state) => state.auth)
    const userData = {
        created_by: user.description,
        modified_by: user.description,
    }
    const { isEdit, title, employee } = props
    const classes = useStyles()
    return (
        <SimpleForm
            validate={(values) => CustomValidater(values, props)}
            style={{ width: '100%' }}
            {...props}
            variant="outlined"
            warnWhenUnsavedChanges
            initialValues={userData}
        >
            <Title title={title} />
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-evenly',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 0.6,
                    }}
                >
                    <div className="container">
                        <div
                            style={{
                                display: 'flex',
                                flex: 0.8,
                                justifyContent: 'space-between',
                            }}
                        >
                            <TextInput
                                style={{ display: 'flex', flex: 0.49 }}
                                variant="outlined"
                                label="Entry #"
                                source="document_no"
                                validate={[required()]}
                                disabled={isEdit}
                            />
                            <DateInput
                                style={{ display: 'flex', flex: 0.49 }}
                                variant="outlined"
                                validate={[required()]}
                                label="Document Date"
                                source="document_date"
                            />
                        </div>
                    </div>
                    <div className="container">
                        <div
                            style={{
                                display: 'flex',
                                flex: 0.8,
                            }}
                        >
                            <SearchReferenceInput
                                {...props}
                                source="employee_id"
                                reference="Employee"
                                allowEmpty
                                validate={required()}
                                perPage={10000}
                                list={EmployeeMasterList}
                                resource="PY_EmployeeMasterTAB"
                                basePath="/PY_EmployeeMasterTAB"
                            />
                        </div>
                    </div>
                    <div className="container">
                        <div
                            style={{
                                flex: 0.8,
                                display: 'flex',
                                justifyContent: 'space-between',
                            }}
                        >
                            <div style={{ display: 'flex', flex: 0.49 }}>
                                <AutocompleteInput
                                    className={classes.field}
                                    source="employee_id"
                                    label="Employee Type"
                                    optionText="description"
                                    optionValue="id"
                                    choices={employee}
                                    variant="outlined"
                                    disabled
                                />
                            </div>
                            <div style={{ display: 'flex', flex: 0.49 }}>
                                <AutocompleteInput
                                    className={classes.field}
                                    source="employee_id"
                                    label="Organization"
                                    optionText="description"
                                    optionValue="id"
                                    choices={employee}
                                    variant="outlined"
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div
                            style={{
                                display: 'flex',
                                flex: 0.8,
                                justifyContent: 'space-between',
                            }}
                        >
                            <NumberInput
                                style={{ display: 'flex', flex: 0.49 }}
                                variant="outlined"
                                validate={[required()]}
                                label="Salary Advance"
                                source="salary_advance"
                            />
                            <DateInput
                                style={{ display: 'flex', flex: 0.49 }}
                                variant="outlined"
                                validate={[required()]}
                                label="Payroll Date For Deduction"
                                source="payrolldate_for_deduction"
                            />
                        </div>
                    </div>
                    <div className="container">
                        <div
                            style={{
                                display: 'flex',
                                flex: 0.8,
                                justifyContent: 'space-between',
                            }}
                        >
                            <NumberInput
                                style={{ display: 'flex', flex: 0.49 }}
                                variant="outlined"
                                validate={[required()]}
                                label="Cash Advance"
                                source="cash_advance"
                            />
                            <NumberInput
                                style={{ display: 'flex', flex: 0.49 }}
                                variant="outlined"
                                validate={[required()]}
                                label="Cash Advance Return"
                                source="cash_advance_return"
                            />
                        </div>
                    </div>
                    <div className="container">
                        <div
                            style={{
                                display: 'flex',
                                flex: 0.8,
                                justifyContent: 'space-between',
                            }}
                        >
                            <NumberInput
                                style={{ display: 'flex', flex: 0.49 }}
                                variant="outlined"
                                validate={[required()]}
                                label="Bouns Advance"
                                source="bonus_advance"
                            />
                            <NumberInput
                                style={{ display: 'flex', flex: 0.49 }}
                                variant="outlined"
                                validate={[required()]}
                                label="Arrears Advance"
                                source="arrears_advance"
                            />
                        </div>
                    </div>
                    <div className="container">
                        <div
                            style={{
                                display: 'flex',
                                flex: 0.8,
                                justifyContent: 'space-between',
                            }}
                        >
                            <NumberInput
                                style={{ display: 'flex', flex: 0.49 }}
                                variant="outlined"
                                validate={[required()]}
                                label="Commission Advance"
                                source="commission_advance"
                            />
                            <div
                                style={{
                                    display: 'flex',
                                    flex: 0.49,
                                    justifyContent: 'space-between',
                                }}
                            >
                                <CustomCheckbox
                                    {...props}
                                    source="is_invoice_immediate"
                                    label="Invoice Immediate"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div
                            style={{
                                display: 'flex',
                                flex: 0.8,
                                justifyContent: 'space-between',
                            }}
                        >
                            <TextInput
                                style={{ display: 'flex', flex: 1 }}
                                variant="outlined"
                                label="Description"
                                source="description"
                                validate={required()}
                            />
                        </div>
                    </div>
                </div>
                <div style={{ flex: 0.3 }}>
                    <div className="container">
                        <TextInput
                            style={{ display: 'flex', flex: 1 }}
                            variant="outlined"
                            disabled
                            label="Created By"
                            source="created_by"
                            validate={required()}
                        />
                    </div>
                    <div className="container">
                        <TextInput
                            style={{ display: 'flex', flex: 1 }}
                            variant="outlined"
                            disabled
                            label="Modified By"
                            source="modified_by"
                            validate={required()}
                        />
                    </div>
                </div>
            </div>
        </SimpleForm>
    )
}

export default function CreateEmployeeAdvance(props) {
    const notify = useNotify()
    const refresh = useRefresh()
    const redirect = useRedirect()
    const [employee, setEmployee] = useState([])
    const { isEdit } = props
    const onSuccess = () => {
        notify(`Changes saved`)
        redirect('/PY_EmployeeAdvanceCardTAB')
        refresh()
    }

    const dataProvider = useDataProvider()

    useEffect(() => {
        dataProvider.getList('PY_EmployeeMasterTAB', {}).then(({ data }) => {
            setEmployee(data)
        })
    }, [dataProvider])

    if (isEdit)
        return (
            <>
                <BackButton path="/PY_EmployeeAdvanceCardTAB" />
                <Edit {...props} undoable={false}>
                    <EmployeeAdvanceComponent
                        employee={employee}
                        title="Edit Employee Advance"
                        isEdit
                    />
                </Edit>
            </>
        )
    return (
        <>
            <BackButton path="/PY_EmployeeAdvanceCardTAB" />
            <Create onSuccess={onSuccess} {...props}>
                <EmployeeAdvanceComponent
                    employee={employee}
                    title="Create Employee Advance"
                    isEdit={false}
                />
            </Create>
        </>
    )
}

CreateEmployeeAdvance.propTypes = {
    isEdit: PropTypes.bool.isRequired,
}

EmployeeAdvanceComponent.propTypes = {
    isEdit: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    employee: PropTypes.arrayOf(PropTypes.object).isRequired,
}
